import {
    lounge,
    lounge1000,
    lounge10000,
    loungeSlugs,
} from '../constants/mfcAccounts'

export interface ILoungeSettings {
    autoPlay: boolean
    timer: number
}

export const calculateLoungeSettings = (
    ueoptValue: number,
): ILoungeSettings => {
    const loungeSettings: ILoungeSettings = {
        autoPlay: true,
        timer: 60,
    }
    switch (ueoptValue) {
        case 0:
            loungeSettings.autoPlay = true
            loungeSettings.timer = 60
            break
        case 1:
            loungeSettings.autoPlay = false
            loungeSettings.timer = 60
            break
        case 2:
            loungeSettings.autoPlay = true
            loungeSettings.timer = 30
            break
        case 3:
            loungeSettings.autoPlay = true
            loungeSettings.timer = 15
            break
    }
    return loungeSettings
}

export const LOUNGE_SESSION_STORAGE_KEY = `LOUNGE_RECENT_MODELS`

export const getRecentModelsFromSession = () => {
    const currentRecentModels = sessionStorage.getItem(
        LOUNGE_SESSION_STORAGE_KEY,
    )
    return currentRecentModels
        ? currentRecentModels.split(',').map((idStr) => Number(idStr))
        : ([] as Array<number>)
}

export const addToLoungeRecentModelsSession = (modelId: number) => {
    const models = getRecentModelsFromSession().slice(-20)
    const recentModels = modelId
        ? [...models.filter((id) => id !== modelId), modelId]
        : models
    sessionStorage.setItem(LOUNGE_SESSION_STORAGE_KEY, recentModels.toString())
    return recentModels
}

export const isLoungeOneThousandEnabled = (rewardsPoints: number) =>
    rewardsPoints >= 1000

export const isLoungeTenThousandEnabled = (rewardsPoints: number) =>
    rewardsPoints >= 10000

export const enabledLounges = (rewardsPoints: number, level?: number) => {
    const lounges = [...loungeSlugs]
    if (!isLoungeTenThousandEnabled(rewardsPoints)) {
        lounges.splice(lounges.indexOf(lounge10000), 1)
    }
    if (!isLoungeOneThousandEnabled(rewardsPoints)) {
        lounges.splice(lounges.indexOf(lounge1000), 1)
    }
    if (!(level >= 2)) {
        lounges.splice(lounges.indexOf(lounge), 1)
    }
    return lounges
}
